
/* CORE-SET funnel events -- listicle step. See scratchpad/wire_tracking.py for why the loader ships with these. */
(function () {
  var run = function () {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.addEventListener('click', function () {
        try {
          posthog.capture('advertorial_cta_click', {
            offer: 'aughs-leaky-gut', page: 'core-two-types-listicle', destination: a.getAttribute('href')
          });
        } catch (e) {}
      });
    });
    var fired = false;
    window.addEventListener('scroll', function () {
      if (fired) return;
      var st = window.scrollY || document.documentElement.scrollTop;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && st / h >= 0.7) {
        fired = true;
        try { posthog.capture('advertorial_complete', { offer: 'aughs-leaky-gut', page: 'core-two-types-listicle' }); } catch (e) {}
      }
    }, { passive: true });
  };
  // Bind after parse. These anchors sit far below this tag, and a querySelectorAll at parse
  // time returns an empty list, then the guard makes the whole block a silent no-op.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
